export const outOfView = (el) => {
  let bounds =
    el && el.firstElementChild && el.firstElementChild.getBoundingClientRect();

  if (!bounds) {
    return [null, {}];
  }

  return [
    bounds,
    {
      top: Math.max(0 - bounds.top, 0),
      left: Math.max(0, 0 - bounds.left),
      bottom: Math.max(0, bounds.bottom - heightViewport()),
      right: Math.max(0, bounds.right - widthViewport()),
    },
  ];
};

const heightViewport = () => {
  return (
    window.innerHeight ||
    (document.documentElement && document.documentElement.clientHeight) ||
    0
  );
};

const widthViewport = () => {
  return (
    window.innerWidth ||
    (document.documentElement && document.documentElement.clientWidth) ||
    0
  );
};

export const calculateYAdjustments = (
  modalRoot,
  bounds,
  outside,
  newStyles,
  arrowHeight
) => {
  const parentBounds =
    modalRoot.current &&
    modalRoot.current.parentElement &&
    modalRoot.current.parentElement.getBoundingClientRect();

  if (noRedrawY(outside) || bounds == null) {
    return null;
  }

  const parentHeight = (parentBounds && parentBounds.height) || 0;
  const direction = outside.bottom <= outside.top ? 1 : -1;
  const distance = direction * (parentHeight + bounds.height + arrowHeight);

  let translateY = null;
  if (newStyles.translateY == undefined || newStyles.translateY == distance) {
    translateY = distance;
  }

  return {
    translateY: translateY,
    direction: direction == -1 ? 'down' : 'up',
  };
};

// Don't redraw is modal is completely bigger or fits into viewport
const noRedrawY = (outside) => {
  return (
    (outside.top > 0 && outside.bottom > 0) ||
    (outside.top == 0 && outside.bottom == 0)
  );
};

const noRedrawX = (outside) => {
  return (
    (outside.left > 0 && outside.right > 0) ||
    (outside.left == 0 && outside.right == 0)
  );
};

export const calculateXAdjustments = (outside, newStyles) => {
  if (noRedrawX(outside)) {
    return null;
  }

  const direction = outside.right <= outside.left ? 1 : -1;
  const distance = direction * Math.max(outside.left, outside.right);

  let translateX = null;
  if (newStyles.translateX == undefined || newStyles.translateX == distance) {
    translateX = distance;
  }
  return { translateX: translateX };
};
